import MissionsList from "./MissionsList";

export default function UrgentMissions() {
  return <MissionsList defaultFilters={{ urgent: true }} />;
}
